// src/InventoryApp.jsx
import React, { useEffect, useState } from 'react';
import { useAuth } from './AuthContext.js';
import ChecklistFlow from './components/ChecklistFlow.jsx';


export default function InventoryApp() {
  const { user, loading } = useAuth();
  const [inventory, setInventory] = useState([]);

  useEffect(() => {
    if (loading) return;
    if (!user) return;
    // not logged in — RequireAuth will redirect you to /login for you


    fetch(
      `/api/inventory?storeId=${encodeURIComponent(user.store)}`,
      { credentials: "include" }
    )
      .then(res => {
        if (!res.ok) throw new Error("Failed to load inventory");
        return res.json();
      })
      .then(data => {
        console.log("📥 API response:", data);  // ✅ PUT IT HERE
        setInventory(data);
      })
      .catch(err => console.error("Error fetching inventory:", err));

  }, [user, loading]);

  const handleChange = (id, field, value) => {
    setInventory(prev =>
      prev.map(item =>
        item.id === id ? { ...item, [field]: value } : item
      )
    );
  };

  if (loading) return null;
  if (!user) return null;

  const generateShoppingList = () => {
    const shoppingList = inventory.filter(
      item => parseFloat(item.quantity || 0) < item.parLevel
    );
    //console.log("🛒 Shopping List:", shoppingList);
    alert("Shopping list generated in console for now.");
  };

  return (
    <div className="p-4">
      <p className="mb-3"><a className="underline" href="/api/sysco/review">View latest Sysco preparation</a></p>
      <ChecklistFlow
        inventory={inventory}
        onChange={handleChange}
        onGenerate={generateShoppingList}
      />
    </div>
  );
}